import { render, staticRenderFns } from "./StudentCreateTabNotes.vue?vue&type=template&id=764577b5&scoped=true&"
import script from "./StudentCreateTabNotes.vue?vue&type=script&lang=js&"
export * from "./StudentCreateTabNotes.vue?vue&type=script&lang=js&"
import style0 from "./StudentCreateTabNotes.vue?vue&type=style&index=0&id=764577b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764577b5",
  null
  
)

export default component.exports